.globeButton {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.5);
  bottom: 0.5em;
  left: 0.5em;
  cursor: pointer;
  padding: 0.125em 0.5em;
  transition: 0.3s ease-in-out background-color;
  &:hover {
    background-color: rgba(255, 255, 255, 1);
  }

  img {
    display: block;
  }
}
